<button type="button" id="btn_FirstRelease" (click)="showFirstReleasePopUp()" style="display:none">POP-UP</button>
<button type="button" id="btnOneMoreReview" (click)="oneMoreReviewConfirm()" style="display:none">OneMoreReview Confirm</button>
<button type="button" id="btnEGApprove" (click)="egTrigger()" style="display:none">OneMoreReview Confirm</button>
<button type="button" id="btnEPTApprove" (click)="eptTrigger()" style="display:none">OneMoreReview Confirm</button>
<button type="button" id="btnReallocate" (click)="reallocate()" style="display:none">OneMoreReview Confirm</button>
<button type="button" id="btnApprove" (click)="approveConfirm()" style="display:none">ApproveConfirm</button>
<button type="button" id="btnQCApprove" (click)="approveQcConfirm()" style="display:none">ApproveConfirm</button>
<button type="button" id="btnMailTo" (click)="mailToTrigger()" style="display:none">MailToTrigger</button>
<button type="button" id="btnDownload" (click)="downloadFile()" style="display:none">btnDownload</button>
<button type="button" id="btnOndemandFirstRelease" (click)="firstReleaseRequest()" style="display:none">btnOndemandFirstRelease</button>
<button type="button" id="btnRevisedFileApprove" (click)="revisedFileapproveConfirm()" style="display:none">ApproveConfirm</button>
<button type="button" id="btnProofingFileApprove" (click)="proofingApproveConfirm()" style="display:none">ApproveConfirm</button>
<button type="button" id="btnProofingConfigReview" (click)="ProofingConfigPreview()" style="display:none"></button>
<button type="button" id="btnOneMoreReviewSignal" (click)="oneMoreReviewSignalConfirm()" style="display:none"></button>
<button type="button" id="btnChangeSpecialIssue" (click)="ChangeSpecialIssue()" style="display:none"></button>
<button type="button" id="btnIsSpecialToNormal" (click)="ChangeSpecialIssueTitle()" style="display:none"></button>
<button type="button" id="btnProofingEPTApprove" (click)="proofingEPTApproveConfirm()" style="display:none">ApproveConfirm</button>
<button type="button" id="btnCompletedDate" (click)="UpdateCompletedDate()" style="display:none">Update CompletedDate</button>

<div class="row">
  <div id="divLoading" style="font-size:16px;margin-left:20px;">
    Please wait loading....
  </div>
  <div id="LoadingImagePopupInfo">
    <img src="assets/Images/loader.gif" class="imgLoadimg" />
  </div>
  <div id="divArtInfo" class="col">
    <div class="row">
      <div class="col-sm-6">
        <div id="divLoadData" style="overflow-x:auto;">
          <table class="tblMain" width="100%">
          </table>
        </div>
      </div>

      <div class="col-sm-6">
        <ul class="nav nav-tabs nav-tabs-custom" id="TabulArticelInfo">
          <li class="nav-item">
            <a data-toggle="tab" href="#Article" class="nav-link active">Article</a>
          </li>
          <li id="tabStandardFR" class="nav-item">
            <a data-toggle="tab" href="#StandardFirstRelease" class="nav-link">Standard First Release</a>
          </li>
          <li id="tabOnDemand" class="nav-item">
            <a data-toggle="tab" href="#FirstRelease" class="nav-link" id="aEFCaption">Early Release</a>
          </li>
          <li class="nav-item" *ngIf="checkRevisedScheduleColumnShow">
            <a data-toggle="tab" href="#Log" class="nav-link">Log</a>
          </li>
          <li class="nav-item" id="tabPrevLog" *ngIf="checkMetadataShow">
            <a data-toggle="tab" href="#PrevLog" class="nav-link">Previous Log</a>
          </li>
          <li class="nav-item" id="tabFigures">
            <a data-toggle="tab" href="#Figures" class="nav-link">Color Info</a>
          </li>
          <li class="nav-item" id="tabGraphics">
            <a data-toggle="tab" href="#Graphics" class="nav-link">Graphics</a>
          </li>
          <li class="nav-item" id="tabXpressParseErrorLog">
            <a data-toggle="tab" href="#XpressParseErrorLog" class="nav-link">Parse Error Log</a>
          </li>

          <li class="nav-item" id="tabIngetsionPackageList">
            <a data-toggle="tab" href="#IngetsionPackageList" class="nav-link">Ingest Package</a>
          </li>

        </ul>

        <br />
        <div class="tab-content">
          <div id="Article" class="tab-pane active">
            <div class="form-group fixTableHead" id="divWorkflow">
              <table id="tblWorkflow" class="dataTable table" style="width: 100%; white-space: normal !important">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Stage</th>
                    <th *ngIf="checkScheduleColumnShow">Planned Date</th>
                    <th *ngIf="checkRevisedScheduleColumnShow && checkScheduleColumnShow">Revised Schedule</th>
                    <th *ngIf="checkRevisedScheduleColumnShow && !checkScheduleColumnShow">Planned Date</th>
                    <th>Actual Completed</th>
                    <th class="dt-head-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                </tbody>
              </table>
            </div>
          </div>
          <div id="StandardFirstRelease" class="tab-pane">
            <div class="form-group fixTableHead" id="divStandardFirstRelease">
              <table id="TblStandardFirstRelease" class="dataTable table" style="width: 100%;white-space:normal !important">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Stage</th>
                    <th>Planned Date</th>
                    <th *ngIf="checkRevisedScheduleColumnShow">Revised Schedule</th>
                    <th>Actual Completed</th>
                    <th class="dt-head-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                </tbody>
              </table>
            </div>
          </div>

          <div id="FirstRelease" class="tab-pane">
            <div class="form-group fixTableHead" id="divFirstRelease">
              <table id="TblFirstRelease" class="dataTable table" style="width: 100%;white-space:normal !important">
                <thead>
                </thead>
                <tbody>
                </tbody>
              </table>
            </div>
          </div>


          <div id="Log" class="tab-pane">
            <div class="form-group fixTableHead" id="divArticleLogList">
              <table id="tblLog" class="dataTable" style="width: 100%;white-space:normal !important">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Process</th>
                    <th>Process By</th>
                    <th>Process Start Date</th>
                    <th>Process End Date</th>
                  </tr>
                </thead>
                <tbody>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Previous Article Log Details -->
          <div id="PrevLog" class="tab-pane">
            <div class="form-group fixTableHead" id="divArticleOldLogList">
              <table id="tbPrevLog" class="dataTable" style="width: 100%; white-space: normal !important">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Process</th>
                    <th>Process By</th>
                    <th>Process Start Date</th>
                    <th>Process End Date</th>
                  </tr>
                </thead>
                <tbody>
                </tbody>
              </table>
            </div>
          </div>

          <!--Article Figure Details-->
          <div id="Figures" class="tab-pane">
            <div class="form-group fixTableHead" id="divArticleFigureList">
              <table id="tbFigures" class="dataTable" style="width: 100%; white-space: normal !important">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Figure Name</th>
                    <th class="dt-head-center">Online Color</th>
                    <th class="dt-head-center">Print Color</th>
                    <th class="dt-head-center">ChargeWaived</th>
                    <th class="dt-head-center">ChargeConfirmed</th>
                  </tr>
                </thead>
                <tbody>
                </tbody>
              </table>
            </div>
          </div>


          <!--Article Graphics Process Details-->
          <div id="Graphics" class="tab-pane">
            <div class="form-group fixTableHead" id="divArticleGraphicsProcess">
              <table id="tbGraphics" class="dataTable" style="width: 100%; white-space: normal !important">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Upload Date</th>
                    <th class="dt-head-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                </tbody>
              </table>
            </div>
          </div>

          <!--Article  Article Xpress Parse Error Log-->
          <div id="XpressParseErrorLog" class="tab-pane">
            <div class="form-group fixTableHead" id="divArticleXpressParseError">
              <table id="tbXpressParseErrorLog" class="dataTable" style="width: 100%; white-space: normal !important">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Response Date</th>
                    <th>Reference No</th>
                    <th>File Name</th>
                    <th class="dt-head-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                </tbody>
              </table>
            </div>
          </div>

          <!--Article Ingestion Package List-->
          <div id="IngetsionPackageList" class="tab-pane">
            <div class="form-group fixTableHead" id="divIngetsionPackageList">
              <table id="tbIngetsionPackageList" class="dataTable" style="width: 100%; white-space: normal !important">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Received Date</th>
                    <th>Transmittal Type</th>
                    <th>Package Name</th>
                    <th class="dt-head-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>

</div>

<div id="myModal_GeneralNotes" class="modal" [style.display]="showNotesModal ? 'block' : 'none'">
  <div class="modal-dialog modal-xl">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title titleNotes"></h4>
        <div type="button" class="close" data-dismiss="modal" (click)="hideNotesModal()">&times;</div>
      </div>
      <div class="modal-body">
        <ul class="nav nav-tabs nav-tabs-custom" id="TabulNotesInfo">
          <li class="nav-item"><a data-toggle="tab" href="#AddNotes" class="nav-link active">Add Notes</a></li>
          <li id="tabNotesHistory" class="nav-item"><a data-toggle="tab" href="#NotesHistory" class="nav-link">Notes History</a></li>
        </ul>

        <br />
        <div class="tab-content">
          <div id="AddNotes" class="tab-pane active">
            <div class="form-group fixTableHead" id="divAddNotes">
              <div class="form-group">
                <textarea class="form-control rounded-0" id="TxtGeneralNote" rows="5"></textarea>
              </div>
              <div class="form-group">
                <label for="FU_NotesAttchment">Attach File</label>
                <div class="custom-file">
                  <input type="file" multiple="" id="FU_NotesAttchment" (change)="fileNotesChangeEvent($event)" />
                </div>
                <!--<app-upload></app-upload>-->
              </div>
            </div>
          </div>
          <div id="NotesHistory" class="tab-pane">
            <div class="form-group fixTableHead" id="divNotesHistory">
              <table id="tblNotesHistory" class="dataTable" style="width: 100%">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Updated By</th>
                    <th>Updated Date</th>
                    <th>Notes</th>
                    <th>Attachment</th>
                  </tr>
                </thead>
                <tbody>
                </tbody>

              </table>
            </div>
          </div>

        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-success waves-effect waves-light" title="Update Notes" (click)="updateArticleNotes()">Update</button>
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" title="Close" (click)="hideNotesModal()" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-outline-info waves-effect waves-light" title="Clear Notes" id="btnClearNotes" (click)="clearArticleNotes()">Clear</button>
      </div>
    </div>
  </div>
</div>

<div id="myModal_HoldRelease" class="modal" [style.display]="showHoldModal ? 'block' : 'none'">
  <div id="LoadingImageHoldRelease">
    <img src="assets/Images/loader.gif" class="imgLoadimg" />
  </div>

  <button type="button" id="btnQueryTypeChange" (click)="GetPopulateQueryType()" style="display:none">MailToTrigger</button>


  <div class="modal-dialog modal-xl custome-modal">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title titleHR"></h4>
        <div type="button" class="close" data-dismiss="modal" (click)="hideHoldModal()">&times;</div>
      </div>
      <div class="modal-body">
        <div class="row">

          <div class="col-12" id="divLeftPanel">

            <div id="divHoldTypeOption" style="display:none" class="col-12">
              <ul class="nav nav-tabs nav-tabs-custom" id="TabulHoldTab" style="top: -20px;position: relative;">
                <li class="nav-item holdGenTab">
                  <a data-toggle="tab" href="#Hold" name="Hold" class="nav-link active" (click)="ChangeHoldType('Hold')">Hold</a>
                </li>
                <li class="nav-item holdGenTab">
                  <a data-toggle="tab" href="#Query" name="Query" class="nav-link"
                     (click)="ChangeHoldType('Query')">Query</a>
                </li>
                <li class="nav-item holdGenTab" id="liNotification" style="display:none">
                  <a data-toggle="tab" href="#Query" name="Notification" class="nav-link"
                     (click)="ChangeHoldType('Notification')">Notification</a>
                </li>
                <li class="nav-item" id="liInComplete" *ngIf="checkOptionIncomplete">
                  <a data-toggle="tab" href="#Query" name="InComplete" class="nav-link"
                     (click)="ChangeHoldType('InComplete')">InComplete</a>
                </li>
              </ul>
            </div>

            <div id="divHoldTopPanel" class="row">
              <div class="col divQueryContent" id="divQueryTypeList" style="display:none">
                <label for="ddlQueryType" id="lblQueryType">Query Type</label><br>
                <select id="ddlQueryType" class="form-control" onchange="$('#btnQueryTypeChange').trigger('click');">
                  <option value="Select" selected>Select</option>
                </select>
              </div>

              <div class="divQueryContent" style="display:none">
                <div class="divQueryMail">
                  <div class="col">
                    <label for="txtQueryFromEmail">From Email</label><br>
                    <input type="text" id="txtQueryFromEmail" class="form-control" />
                  </div>

                  <div class="col">
                    <label for="txtQueryToEmail">To Email</label><br>
                    <input type="text" id="txtQueryToEmail" class="form-control" />
                  </div>

                  <div class="col">
                    <label for="txtQueryCcEmail">Cc Email</label><br>
                    <input type="text" id="txtQueryCcEmail" class="form-control" />
                  </div>
                  <div class="col">
                    <label for="txtQueryBccEmail">Bcc Email</label><br>
                    <input type="text" id="txtQueryBccEmail" class="form-control" />
                  </div>
                </div>
              </div>

            </div>

            <div class="row divHoldContent">
              <div class="form-group">
                <label for="txtHold" class="control-label" id="LblHoldText">On Hold Notes</label>
                <textarea class="form-control rounded-0" id="txtHold" rows="8"></textarea>
              </div>
              <div class="form-group" id="divRelease">
                <label for="txtRelease" class="control-label">Response</label>
                <textarea class="form-control rounded-0" id="txtRelease" rows="8"></textarea>
              </div>
            </div>

            <div class="col row">
              <br />
              <div class="form-group">
                <label for="FU_HRAttchment">Attach File</label>
                <div class="custom-file">
                  <input type="file" id="FU_HRAttchment" (change)="fileHRChangeEvent($event)" multiple />
                </div>
              </div>
              <div class="form-group col-3" id="divDueDateRelease">
                <label for="Txt_HoldDueDate">Due Date</label>
                <input type="date" class="form-control float-right" id="Txt_HoldDueDate">
              </div>
            </div>

          </div>

          <div class="col-7 divQueryMail" id="divRightPanel">
            <div class="row divQueryContent" style="display:none">
              <div class="col">
                <label for="txtQuerySubject">Subject</label><br>
                <input type="text" id="txtQuerySubject" class="form-control" />
              </div>

              <div class="col" id="divQueryMailBodyPanel">
                <label for="txtQueryMailBody">Mail Body</label><br>
                <textarea class="form-control rounded-0" id="txtQueryMailBody" rows="10" data-origin="textarea"></textarea>
              </div>
            </div>
          </div>

        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-success waves-effect waves-light" title="Hold Release" (click)="updateHoldRelease()" id="btnHoldRelease">Update</button>
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" title="Close" (click)="hideHoldModal()" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>

</div>

<div id="myModal_HoldReleaseHistory" class="modal" [style.display]="showHoldHistoryModal ? 'block' : 'none'">
  <div class="modal-dialog modal-xl">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title titleHRH"></h4>
        <div type="button" class="close" data-dismiss="modal" (click)="hideHoldHistoryModal()">&times;</div>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <table id="tblHoldHistory" class="dataTable table" style="width: 100%">
            <thead>
              <tr>
                <th>#</th>
                <th>Raised By</th>
                <th>Date</th>
                <th>Prod.Query</th>
                <!--<th>Query Activity</th>-->
                <th>Query File</th>
                <th>Responsed By</th>
                <th>Responsed Date</th>
                <th>Response</th>
                <!--<th>Response Activity</th>-->
                <th>Response File</th>
              </tr>
            </thead>
            <tbody>
            </tbody>

          </table>

        </div>
      </div>
      <div class="modal-footer">

      </div>
    </div>
  </div>
</div>

<div id="myModal_AtypeonCorrections" class="modal" role="dialog">
  <div class="modal-dialog modal-xl">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Atypeon Upload</h4>
        <div type="button" class="close" data-dismiss="modal" (click)="hideAtypeonCorrectionModal()">&times;</div>
      </div>
      <div class="modal-body" name="correctionPopup">

        <div class="form-group">
          <label for="FU_AtypeonAttchment">Correction File</label>
          <div class="custom-file">
            <input type="file" id="FU_AtypeonAttchment" (change)="fileAtypeonChangeEvent($event)" />
          </div>
          <!--<app-upload></app-upload>-->
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnAtpeonCorrections" (click)="updateAtypeonCorrection()">Upload Correction</button>
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideAtypeonCorrectionModal()">Close</button>
      </div>
    </div>
    <div id="LoadingImagePopupAtypeon">
      <img src="assets/Images/loader.gif" class="imgLoadimg" />
    </div>
  </div>
</div>

<div id="myModal_QCCorrections" class="modal" role="dialog">
  <div class="modal-dialog modal-xl">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">QC Corrections</h4>
        <div type="button" class="close" data-dismiss="modal" (click)="hideQCCorrectionModal()">&times;</div>
      </div>
      <div class="modal-body" name="correctionPopup">

        <div class="form-group">
          <label for="TxtQCInstruction">Instructions</label>
          <textarea class="form-control rounded-0" id="TxtQCInstruction" rows="5"></textarea>
        </div>
        <div class="form-group">
          <label for="FU_QCAttchment">Correction File</label>
          <div class="custom-file">
            <input type="file" id="FU_QCAttchment" (change)="fileQCChangeEvent($event)" />
          </div>
          <!--<app-upload></app-upload>-->
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnCorrections" (click)="updateQCCorrection()">Upload Correction</button>
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideQCCorrectionModal()">Close</button>
      </div>
    </div>
    <div id="LoadingImagePopupQC">
      <img src="assets/Images/loader.gif" class="imgLoadimg" />
    </div>
  </div>
</div>

<div id="myModal_Corrections" class="modal" role="dialog" [style.display]="showCorrectionModal ? 'block' : 'none'">
  <div class="modal-dialog modal-xl">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Further Corrections</h4>
        <div type="button" class="close" data-dismiss="modal" (click)="hideCorrectionModal()">&times;</div>
      </div>
      <div class="modal-body" name="correctionPopup">
        <div class="col">
          <!--<div class="form-group col-4">
            <label for="ddlCorrectionType">Correction Type</label><br>
            <select id="ddlCorrectionType" class="form-control select2" style="width: 100%;">
              <option value="ManualPagination">Send for Manual Pagination</option>
              <option value="VendorCorrection">Send Package to Vendor</option>
            </select>
          </div>-->
          <div class="form-group col CorrectionInputInstructions">
            <label for="TxtInstruction">Instructions</label>
            <textarea class="form-control rounded-0" id="TxtInstruction" rows="5"></textarea>
          </div>
          <div class="row col">
            <div class="col-6">
              <div class="form-group col CorrectionInputFile">
                <label for="FU_Attchment">Correction File</label>
                <div class="custom-file">
                  <input type="file" id="FU_Attchment" (change)="fileChangeEvent($event)" />
                </div>
              </div>
              <div class="form-group col-3">
                <label for="Txt_DueDate">Due Date</label>
                <input type="date" class="form-control float-right" id="Txt_DueDate">
              </div>
            </div>
            <div class="col-6" id="divCorrTypeXmlPdf" style="display:none">
              <div class="form-group col-6">
                <label for="ddlCorrTypeXmlPdf">Correction Type</label><br>
                <select id="ddlCorrTypeXmlPdf" class="form-control select2" (change)="ChangeCorrXmlPdf()">
                  <option value="Select">Select</option>
                  <option value="Xml">Xml</option>
                  <option value="Pdf">Pdf</option>
                </select>
              </div>
              <div class="form-group col-6" id="divCorrTypeEpubDate" style="display:none">
                <label for="Txt_EpubDateCorrection">EPub Date</label>
                <input type="date" class="form-control float-right" id="Txt_EpubDateCorrection">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnPMCorrections" (click)="updateArticleCorrection()">Corrections</button>
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideCorrectionModal()">Close</button>
      </div>
    </div>
    <div id="LoadingImagePopup1">
      <img src="assets/Images/loader.gif" class="imgLoadimg" alt="" />
    </div>
  </div>
</div>

<div id="myModal_EPTCorrections" class="modal" role="dialog" [style.display]="showEPTCorrectionModal ? 'block' : 'none'">
  <div class="modal-dialog modal-lg">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Corrections</h4>

      </div>
      <div class="modal-body" name="correctionEptPopup">
        <div class="col">

          <div class="form-group col CorrectionInputInstructions">
            <label for="TxtEPTInstruction">Instructions</label>
            <textarea class="form-control rounded-0" id="TxtEPTInstruction" rows="5"></textarea>
          </div>
          <div class="form-group col CorrectionInputFile">
            <label for="FU_EPTAttchment">Correction File</label>
            <div class="custom-file">
              <input type="file" id="FU_EPTAttchment" (change)="fileEPTChangeEvent($event)">
            </div>
          </div>

        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnEPTCorrections" (click)="updateProofingEPTCorrection()">Corrections</button>
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideEPTCorrectionModal()">Close</button>
      </div>
    </div>
    <div id="LoadingImagePopupEPTCorrection">
      <img src="assets/Images/loader.gif" class="imgLoadimg" alt="" />
    </div>
  </div>
</div>

<div id="myModal_Review" class="modal" role="dialog" [style.display]="showReviewModal ? 'block' : 'none'">
  <div class="modal-dialog modal-xl" id="mymodel_Review">
    <!-- Modal content-->
    <div class="modal-content" id="mymodel_contentReview">
      <div class="modal-header" style="top: -10px; position: relative;">

        <h4 class="modal-title">Send to Review</h4>
        <div type="button" class="close" data-dismiss="modal" (click)="hideReviewModal()">×</div>
      </div>
      <div class="modal-body" style="overflow: hidden !important; position: relative; top: -30px;">
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label for="ddlMailTo">Select</label><br>
              <select id="ddlMailTo" class="form-control select2" style="width: 100%;" onchange="$('#btnMailTo').trigger('click')">
                <option *ngFor="let item of lAuthorList" value={{item.ProofToEmailId}}>
                  {{item.ProofToEmailId}}
                </option>
                <option [value]="0">Custom</option>
              </select>
              <!-- <select id="ddlMailTo" class="form-control"></select>-->
            </div>
            <div class="form-group">
              <label>Mail To</label>
              <input id="TxtMailTo" type="text" class="form-control TxtMailTo emailinput ei" contenteditable="false">
            </div>
            <div class="form-group">
              <label>Mail CC</label>
              <input id="TxtMailCC" type="text" class="form-control">
            </div>
            <div class="form-group">
              <label>Mail BCC</label>
              <input id="TxtMailBCC" type="text" class="form-control">
            </div>
          </div>
          <div class="col-sm-8">

            <ul class="nav nav-tabs nav-tabs-custom" id="TabOneMoreReview">
              <li class="nav-item">
                <a data-toggle="tab" href="#ProofMail" class="nav-link active">Proof Mail</a>
              </li>
              <li id="tabStandardFR" class="nav-item">
                <a data-toggle="tab" href="#ProofConfirmation" class="nav-link">Confirmation Mail</a>
              </li>
            </ul>
            <div class="tab-content">
              <div id="ProofMail" class="tab-pane active">
                <div class="form-group">
                  <label>Subject</label>
                  <input id="TxtMailSubject" type="text" class="form-control">
                </div>
                <div class="form-group" id="Divmail">
                  <label>Mail Body</label>
                  <textarea class="form-control rounded-0 ReviewPopup" id="TxtMailBody" rows="5" data-origin="textarea"></textarea>
                </div>
              </div>

              <div id="ProofConfirmation" class="tab-pane">
                <div class="form-group">
                  <label>Subject</label>
                  <input id="TxtConfirmationMailSubject" type="text" class="form-control">
                </div>
                <div class="form-group" id="DivConfirmail">
                  <label>Mail Body</label>
                  <textarea class="form-control rounded-0 ReviewPopup" id="TxtConfirmationMailBody" rows="5" data-origin="textarea"></textarea>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnSend" (click)="oneMoreReviewConfirm()">Send</button>
          <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideReviewModal()">Close</button>
        </div>

      </div>

    </div>
  </div>
  <div id="LoadingImagePopup2">
    <img src="assets/Images/loader.gif" class="imgLoadimg" alt="" />
  </div>
</div>

<div id="divAllocatePopup" class="modal">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">User Allocate Confirmation</h3>
        <div type="button" class="close" data-dismiss="modal" (click)="hideAllocateModal()">×</div>
      </div>
      <div class="modal-body" style="overflow-x:hidden !important">

        <div class="row ">
          <div class="col-12">
            <label>Allocate</label><br>
            <select id="ddlAllocateUser" class="form-control select2">
              <option value="SelfAllocate">Self Allocate</option>
              <option value="OthersAllocate">Others Allocate</option>
            </select>
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-success waves-effect waves-light" title="Allocate and Download" (click)="UpdateAllocateUser()">Confirm</button>
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" title="Close" (click)="hideAllocateModal()" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
  <div id="LoadingImagAllocatePopup">
    <img src="assets/Images/loader.gif" class="imgLoadimg" alt="" />
  </div>
</div>

<div id="myModal_AtypeonHistory" class="modal">
  <div class="modal-dialog modal-xl">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title titleAH"></h4>
        <div type="button" class="close" data-dismiss="modal" (click)="hideAtypeonHistoryModal()">&times;</div>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <table id="tblAtypeonHistory" class="dataTable" style="width: 100%">
            <thead>
              <tr>
                <th>Failure Notes</th>
              </tr>
            </thead>
            <tbody>
            </tbody>

          </table>

        </div>
      </div>

    </div>
  </div>
</div>

<div id="myModal_ReferenceNote" class="modal skipDisabled" role="dialog" [style.display]="showCorrectionModal ? 'block' : 'none'">
  <div class="modal-dialog modal-xl">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="hRefNoteTitle">Reference Note</h4>
        <div type="button" class="close" data-dismiss="modal" (click)="HideReferenceNote()">&times;</div>
      </div>
      <div class="modal-body" id="ReferenceNotePopup">
        <div class="col">

          <div class="form-group col">
            <label for="TxtInstructionRN">Instructions</label>
            <textarea class="form-control rounded-0" id="TxtInstructionRN" rows="5"></textarea>
          </div>
          <div class="form-group col">
            <label for="FU_AttchmentRN">Reference File</label>
            <div class="custom-file">
              <input type="file" id="FU_AttchmentRN" (change)="RefNoteFileChangeEvent($event)" />
            </div>
          </div>
          <div class="form-group col">
            <div (click)="DownloadReferenceNoteFile()" title="Click to download"><span class="spDTIcon" id="arefDownload"></span></div>
          </div>

        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnRefNote" (click)="ReferenceNoteUpload()">Update</button>
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="HideReferenceNote()">Close</button>
      </div>
    </div>
    <div id="LoadingImagePopupRN">
      <img src="assets/Images/loader.gif" class="imgLoadimg" alt="" />
    </div>
  </div>
</div>

<div id="myModal_MailPreview" class="modal" role="dialog">
  <div class="modal-dialog modal-xl" id="mymodel_Preview">
    <!-- Modal content-->
    <div class="modal-content" id="mymodel_contentPreview">
      <div class="modal-header">
        <h4 class="modal-title">Proofing Config Preview</h4>
        <div type="button" class="close" data-dismiss="modal" (click)="HidePreviewModal()">×</div>
      </div>
      <div class="modal-body">
        <div class="row">
          <div id="divPreviewMain" style="overflow: hidden; overflow-y: auto;">
            <div id="divPreviewData"></div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnSend" (click)="OneMoreReviewSignalUpdate()">Approve</button>
          <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="HidePreviewModal()">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="myModal_JrlNotes" class="modal" role="dialog">
  <div class="modal-dialog modal-xl" id="mymodel_JrlNotes">
    <!-- Modal content-->
    <div class="modal-content" id="mymodel_JrlNotes">
      <div class="modal-header">
        <h4 class="modal-title" id="jrlNotesTitle">Common Checklist</h4>
        <div type="button" class="close" data-dismiss="modal" (click)="HideJrlNotesModal()">×</div>
      </div>
      <div class="modal-body">
        <div class="row">
          <div id="divJrlNotesMain" style="overflow: hidden; overflow-y: auto;">
            <div id="divJrlNotesData"></div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnSend" (click)="ApprovalFromJrlNotes()">Approve</button>
          <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="HideJrlNotesModal()">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="myModal_StageDateChange" class="modal" role="dialog">
  <div class="modal-dialog" id="mymodel_StageDateChange">
    <!-- Modal content-->
    <div class="modal-content" id="mymodel_StageDateChange">
      <div class="modal-header">
        <h4 class="modal-title" id="StageDateChangeTitle">Stage Date Change</h4>
        <div type="button" class="close" data-dismiss="modal" (click)="HideStageDateChange()">×</div>
      </div>
      <div class="modal-body">
        <div class="col">
          <label for="Txt_StageChangeDate">Change Date</label>
          <input type="date" class="form-control float-right" id="Txt_StageChangeDate">
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnSend" (click)="UpdateCompletedDate()">Update</button>
          <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="HideStageDateChange()">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="myModal_PubDate" class="modal" role="dialog">
  <div class="modal-dialog" id="mymodel_PubDate">
    <!-- Modal content-->
    <div class="modal-content" id="mymodel_PubDate">
      <div class="modal-header">
        <h4 class="modal-title">Approve Article</h4>
        <div type="button" class="close" data-dismiss="modal" (click)="HidePubDateApproval()">×</div>
      </div>
      <div class="modal-body">
        <div class="col">
          <label for="TxtPopEpubDate">EPub-Date</label>
          <input type="date" class="form-control float-right" id="TxtPopEpubDate" name="changeValueMetaInfo">
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnSend" (click)="ApproveWithPubDate()">Approve</button>
          <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="HidePubDateApproval()">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="myModal_CID" class="modal" role="dialog">
  <div class="modal-dialog modal-sm" id="myModelCID">
    <!-- Modal content-->
    <div class="modal-content" id="mymodel_CID">
      <div class="modal-header">
        <h4 class="modal-title" id="CIDTitle">Approve Article</h4>
        <div type="button" class="close" data-dismiss="modal" (click)="HideCIDModal()">×</div>
      </div>
      <div class="modal-body">
        <div class="row">
          <div id="divCIDMain" style="overflow: hidden; overflow-y: auto;">
            <span>
              CID&nbsp;
              <span class="tooltip1">
                <i class="fa fa-info-circle iCID" data-toggle="tooltip" data-html="true" data-title="" title="CID" id="iCIDList"></i>
                <span class="tooltiptext1" id="Divlist"></span>
              </span>
              <input id="TxtCID" type="text" class="form-control" maxlength="6" disabled />
            </span>
            <div class="form-group col-12 PublishDateApp" style="display:none;">
              <label for="Txt_PublDate">Publish Date</label>
              <input type="date" class="form-control float-right" id="Txt_PublDate" (change)="GetCID()">
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnSend" (click)="ApprovalFromJrlNotes()">Approve</button>
          <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="HideCIDModal()">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="myModal_ApproveAttach" class="modal" role="dialog">
  <div class="modal-dialog" id="mymodel_PubDate">
    <!-- Modal content-->
    <div class="modal-content" id="mymodel_ApproveAttach">
      <div class="modal-header">
        <h4 class="modal-title">Approve Article</h4>
        <div type="button" class="close" data-dismiss="modal" (click)="HideApproveAttach()">×</div>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="FU_ApproveAttchment">Attach File</label>
          <div class="custom-file">
            <input type="file" id="FU_ApproveAttchment" (change)="fileApproveAttachChangeEvent($event)" />
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnApproveAttach"
                  (click)="ApproveAttachConfirm()">
            Approve
          </button>
          <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal"
                  (click)="HideApproveAttach()">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="myModal_ExpressCorrections" class="modal" role="dialog">
  <div class="modal-dialog modal-xl">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Corrections</h4>
        <div type="button" class="close" data-dismiss="modal" (click)="HideExpressCorrectionModal()">&times;</div>
      </div>
      <div class="modal-body" name="ExpressCorrectionPopup">
        <div class="col">
          <div class="form-group col-4">
            <label for="ddlExpressCorrectionType">Correction Type</label><br>
            <select id="ddlExpressCorrectionType" class="form-control select2" style="width: 100%;">
              <option value="Graphics">Graphics</option>
              <option value="Pre-editing-review">Pre-editing-review</option>
              <!--<option value="Xml">Xml</option>
              <option value="Both">Both</option>-->
            </select>
          </div>
          <div class="form-group col">
            <label for="TxtECInstruction">Instructions</label>
            <textarea class="form-control rounded-0" id="TxtECInstruction" rows="5"></textarea>
          </div>
          <div class="row col">
            <div class="col-6">
              <div class="form-group col">
                <label for="FU_ECAttchment">Correction File</label>
                <div class="custom-file">
                  <input type="file" id="FU_ECAttchment" (change)="fileChangeEvent($event)" />
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-success waves-effect waves-light"
                (click)="UpdateExpressCorrection()">
          Corrections
        </button>
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal"
                (click)="HideExpressCorrectionModal()">
          Close
        </button>
      </div>
    </div>

  </div>
</div>


<div id="myModal_ExpressCorrectionUpload" class="modal" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="ecuTitle">Correction Upload File</h4>
        <div type="button" class="close" data-dismiss="modal" (click)="HideExpressCorrectionUploadModal()">&times;</div>
      </div>
      <div class="modal-body" name="ExpressCorrectionUploadPopup">
        <div class="col">
          <div class="row col">
            <div class="col-6">
              <div class="form-group col">
                <div class="custom-file">
                  <input type="file" id="FU_ECUAttchment" (change)="fileChangeEvent($event)" />
                </div>
                <em>{{MsgCorrectionError}}</em>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-success waves-effect waves-light"
                (click)="ExpressCorrectionUpload()">
          Upload
        </button>
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal"
                (click)="HideExpressCorrectionUploadModal()">
          Close
        </button>
      </div>
    </div>

  </div>
</div>


<div id="myModal_ManuscriptFile" class="modal" role="dialog">
  <div class="modal-dialog modal-x">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Manuscript File</h4>
        <div type="button" class="close" data-dismiss="modal" (click)="HideManuscriptFileModal()">&times;</div>
      </div>
      <div class="modal-body" name="ManuscriptFilePopup">
        <div class="col">

          <div id="divManuFileList"></div>

        </div>
      </div>
      <div class="modal-footer">

        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal"
                (click)="HideManuscriptFileModal()">
          Close
        </button>
      </div>
    </div>
    <div id="LoadingImagePopupMF">
      <img src="assets/Images/loader.gif" class="imgLoadimg" alt="" />
    </div>
  </div>
</div>


<div id="myModal_Delay" class="modal" role="dialog">

  <div class="modal-dialog modal-xl" id="myModelDelay">

    <!-- Modal content-->

    <div class="modal-content" id="mymodel_Delay">

      <div class="modal-header">

        <h4 class="modal-title" id="DelayTitle">Approve Article</h4>

        <div type="button" class="close" data-dismiss="modal" (click)="HideDelayModal()">×</div>

      </div>

      <div class="modal-body">

        <div class="row">

          <div id="divDelayMain" style="overflow: hidden; overflow-y: auto;">

            <span>

              Delay Reason&nbsp;

              <input id="TxtDelayReason" type="text" class="form-control" />

            </span>

          </div>

        </div>

        <div class="modal-footer">

          <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnSend" (click)="ApprovalFromDelay()">Approve</button>

          <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="HideDelayModal()">Close</button>

        </div>

      </div>

    </div>

  </div>

</div>

<button type="button" id="btnArticleAction" (click)="ShowArticleAction()" style="display:none"></button>

<div id="myModal_ArticleAction" class="modal" [style.display]="showArticleAction ? 'block' : 'none'">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Article Action</h4>
        <div type="button" class="close" data-dismiss="modal" (click)="HideArticleAction()">&times;</div>
      </div>
      <div class="modal-body">
        <div class="form-group">
          
          <select id="ddlActionType" class="form-control">
            <option value="Select">-- Select Action --</option>
            <option value="Retypesetting">Retypesetting</option>
            <option value="Withdrawn">Withdrawn</option>
            <option value="Delete">Delete</option>
            <option value="ReadytoPublishChange">Ready to Publish Change (No->Yes)</option>
          </select>
        </div>
      </div>
      <div class="modal-footer">

        <button type="button" class="btn btn-outline-success waves-effect waves-light"
                (click)="UpdateArticleAction()">Update</button>

        <button type="button" class="btn btn-outline-danger waves-effect waves-light"
                data-dismiss="modal" (click)="HideArticleAction()">Close</button>

      </div>
    </div>
  </div>
</div>


<input type="file" id="FU_iCodexFlexyPageUpload" multiple style="display:none" (change)="oniCodexFlexyPageFileSelected($event)" />
